"use client";

import ClickHandler from "./ClickHandler";
import { isAmcClpPage } from "./amcClpPageUtils";
import { shouldStopPropagationForHeaderSsoLink } from "./headerSsoLinkUtils";

/**
 * ClickHandler preconfigured for apps using shared HeaderFooter (Sign In / Cart).
 * Stops duplicate navigation from header onClick handlers + global ClickHandler.
 * On the AMC CLP page, skips legacy dataLayer CT so amc-clp-libs owns click analytics.
 */
export default function ClickHandlerWithHeaderSsoFix() {
  return (
    <ClickHandler
      shouldStopPropagation={shouldStopPropagationForHeaderSsoLink}
      shouldSkipAnalytics={isAmcClpPage}
    />
  );
}
